import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/shared/lib/utils";

export const inputVariants = cva(
  "flex w-full min-w-0 transition-[color,box-shadow] outline-none file:inline-flex file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      variant: {
        // Admin 스타일 (기존 shadcn 스타일)
        admin: [
          "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input",
          "h-9 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs md:text-sm",
          "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
          "aria-invalid:ring-destructive/20 aria-invalid:border-red-error",
          "file:h-7",
        ],
        // Public 스타일 (기존 프로젝트 스타일)
        public: [
          "body-md-regular h-[46px] tb:h-[52px] rounded-[8px] tb:rounded-10 border border-gray-200 bg-white px-4 text-gray-900 placeholder:text-gray-400",
          "focus:border-primary-500 focus:ring-0 focus:outline-none",
          "disabled:bg-gray-50 disabled:text-gray-400",
          "read-only:bg-gray-50 read-only:text-gray-500",
          "aria-invalid:border-red-error aria-invalid:ring-red-error/20",
          "file:body-md-regular file:text-gray-400 ",
        ],
      },
    },
    defaultVariants: {
      variant: "admin",
    },
  },
);

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement>, VariantProps<typeof inputVariants> {
  ref?: React.Ref<HTMLInputElement>;
}

function Input({ className, variant, type, ref, ...props }: InputProps) {
  return (
    <input ref={ref} type={type} data-slot="input" className={cn(inputVariants({ variant, className }))} {...props} />
  );
}

export { Input };
